// src/config/apiConfig.js

// export const API_URL = 'http://localhost:5000';
// export const WS_URL = 'ws://localhost:8080';

export const API_URL = 'https://apitic-tac.ntgarage.com';
export const WS_URL = 'wss://ws-tac.ntgarage.com';
